var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM17.475 9.975L10.5 16.95C10.275 17.175 9.975 17.25 9.675 17.25C9.375 17.25 9.075 17.175 8.85 16.95L6 14.1C5.55 13.65 5.55 12.975 6 12.525C6.45 12.075 7.125 12.075 7.575 12.525L9.675 14.625L15.9 8.4C16.35 7.95 17.025 7.95 17.475 8.4C17.925 8.85 17.925 9.525 17.475 9.975Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M10.5074 16.9373L17.4824 9.96231C17.9324 9.51231 17.9324 8.8373 17.4824 8.3873C17.0324 7.9373 16.3574 7.9373 15.9074 8.3873L9.68242 14.6123L7.58242 12.5123C7.13242 12.0623 6.45742 12.0623 6.00742 12.5123C5.55742 12.9623 5.55742 13.6373 6.00742 14.0873L8.85742 16.9373C9.08242 17.1623 9.38242 17.2373 9.68242 17.2373C9.98242 17.2373 10.2824 17.1623 10.5074 16.9373Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1e07006b.svg";
export { ForwardRef as ReactComponent };